import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import ContentDiv from "../../utils/ContentDiv";
import SuccessWrap from "../../utils/error-success/SuccessWrap";

class CreateSuccess extends Component {
	render() {
		const { translations } = this.props;

		return (
			<React.Fragment>
				<SuccessWrap>
					<ContentDiv>
						{translations.sections.reviewer_registration_form.success_message}
					</ContentDiv>
				</SuccessWrap>
				<br />

				<div className="centered">
					{translations.sections.reviewer_registration_form.check_email_notification}
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(CreateSuccess);



// WEBPACK FOOTER //
// ./src/components/reviewer/create/CreateSuccess.js